import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

// Enum options extracted from Ruby IssuerEventConcern::Enums
export const timeOfTheDayOptions = [
  { value: "before_market", label: "Before Market" },
  { value: "morning", label: "Morning" },
  { value: "after_market", label: "After Market" },
  { value: "afternoon", label: "Afternoon" },
];

export const eventTypeOptions = [
  { value: "earnings", label: "Earnings" },
  { value: "council", label: "Council" },
  { value: "bank_holiday", label: "Bank Holiday" },
  { value: "press_conference", label: "Press Conference" },
  { value: "other", label: "Other" },
  { value: "political", label: "Political" },
];

export const filterIssuerEventSchema = z.object({
  time_of_the_day_contains: z.string().nullable().optional(),
  event_type_contains: z.string().nullable().optional(),
});

export type FilterIssuerEventSchema = z.infer<typeof filterIssuerEventSchema>;

export const fields: Field[] = [
  {
    name: "time_of_the_day_contains",
    label: "Time of Day",
    type: "select",
    useTranslation: false,
    options: timeOfTheDayOptions,
  },
  {
    name: "event_type_contains",
    label: "Event Type",
    type: "select",
    useTranslation: false,
    options: eventTypeOptions,
  },
];

export const client = "legacy-quantilia";

export function FilterIssuerEvent() {
  return (
    <FilterTable
      client={client}
      schema={filterIssuerEventSchema}
      tableName="issuer_events"
      customBuildPath={() => `${client}/issuer_events`}
      fields={fields}
    />
  );
}
